/**
 * @generated SignedSource<<9cf0ae6511a37d75ded81543409bc20a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type salesOrderBaseFragment$data = {
  readonly id: string;
  readonly externalRef: string;
  readonly accountId: string | null;
  readonly userId: string | null;
  readonly customerEmail: string;
  readonly customerFirstName: string | null;
  readonly customerLastName: string | null;
  readonly status: string;
  readonly meta: any | null;
  readonly eventRecurringId: string | null;
  readonly createdAt: any | null;
  readonly updatedAt: any | null;
  readonly deletedAt: any | null;
  readonly " $fragmentType": "salesOrderBaseFragment";
};
export type salesOrderBaseFragment$key = {
  readonly " $data"?: salesOrderBaseFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"salesOrderBaseFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "salesOrderBaseFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalRef",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customerEmail",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customerFirstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customerLastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "meta",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventRecurringId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "deletedAt",
      "storageKey": null
    }
  ],
  "type": "SalesOrder",
  "abstractKey": null
};

(node as any).hash = "7cfe6f85be9ca7395c6bc1f3751026d8";

export default node;
